import React from 'react';
import './App.scss';
//Import React Scrit Libraray to load Google object
import Script from 'react-load-script';
import { CSVLink, CSVDownload } from "react-csv";
import {CAPTIONS} from "./Captions.js"
import { renderEmail } from 'react-html-email'
import MyEmail from './Email';
import logo from "./logowhite.png";
import axios from 'axios';
import Modal from "./Modal.js";

const Slider = ({header, val, valFormat, onChange, minVal, maxVal, typeId, annual, showModal, hideModal, showLabel, descrip, name}) => {
  return(
    <div className='slider-container'>
      <div className="slider-caption-container">
        <p className="input-caption">{header} {annual? "(annual)" : null}</p>
        {
          descrip?
          <div className="question-container">
            <button className='help-icon' onMouseEnter={() => {showModal(name)}} onMouseLeave={() => {hideModal(name)}}>
              <i className="far fa-question-circle"></i>
            </button>
            {
              showLabel ?
              <div className="label-container">
                <p className="label-text">{descrip}</p>
              </div>
              : null
            }
          </div>
          : null
        }

      </div>
      <div>
        <label className="slide-caption">
          $<input
            type="text"
            placeholder={"0"}
            value={val}
            onChange={(e) => {onChange(e, typeId)}}
            className="slider-input"></input>
          <input
            type="range"
            min={minVal}
            max={maxVal}
            value={val}
            className="slider"
            onChange={(e) => {onChange(e, typeId)}}
            />
        </label>
      </div>
    </div>
  )
}

const InputBar = ({header, placeholder, val, onChange, downPercent, onDownPercentChange = null, showModal, hideModal, showLabel, descrip, name, inputClass, containerClass}) => {
  return(
    <div className={containerClass}>
      <div className="input-caption-container">
        <p className="input-caption">{header}</p>
        {
          descrip?
          <div className="question-container">
            <button className='help-icon' onMouseEnter={() => {showModal(name)}} onMouseLeave={() => {hideModal(name)}}>
              <i className="far fa-question-circle"></i>
            </button>
            {
              showLabel ?
              <div className="label-container">
                <p className="label-text">{descrip}</p>
              </div>
              : null
            }
          </div>
          : null
        }

        {
          onDownPercentChange ?
          <div className="radio-container">
            <div className="radio-col">
              <label for="down1" className="radio-text">10%</label>
              <input type="radio" id="down1" name="down" value="10" onChange={(e) => {onDownPercentChange(e)}}  className="radio-button"/>
            </div>
            <div className="radio-col">
              <label for="down2" className="radio-text">20%</label>
              <input type="radio" id="down2" name="down" value="20" onChange={(e) => {onDownPercentChange(e)}}  className="radio-button"/>
            </div>
            <div className="radio-col">
              <label for="down3" className="radio-text">25%</label>
              <input type="radio" id="down3" name="down" value="25"  onChange={(e) => {onDownPercentChange(e)}} className="radio-button" checked={downPercent == 25}/>
            </div>
          </div>
          : null
        }

      </div>
      <input
        type="text"
        placeholder={placeholder}
        value={val}
        onChange={(e) => {onChange(e)}}
        className={inputClass}></input>
    </div>
  )
}


const CategoryResults = ({header1, sub1, val1, header2, sub2, val2, showModal, hideModal, showLabel, descrip, name}) => {
  return (
      <div className="mortgage-calculated">
        <div className="caption-container">
          <div className="caption">
          <p className="small-head">{header1}</p>
            {
              descrip?
              <div className="question-container">
                <button className='help-icon' onMouseEnter={() => {showModal(name)}} onMouseLeave={() => {hideModal(name)}}>
                  <i className="far fa-question-circle"></i>
                </button>
                {
                  showLabel ?
                  <div className="label-container">
                    <p className="label-text">{descrip}</p>
                  </div>
                  : null
                }
              </div>
              : null
            }
          </div>
        </div>
        <p className="small-number">{val1}</p>
      </div>
  )
}


const API_PATH = 'http://localhost:8080/investment-mailer.php';

class App extends React.Component {

  constructor(props){
    super(props);
    this.autocomplete = null;
    this.state={
      purchasePrice: '',
      captions: CAPTIONS,
      x: 0,
      y: 0,
      downPayment: '',
      mortgageAmount: '',
      purchaseInt: 500000,
      downInt: 125000,
      mortgageInt: 375000,
      downPercent: 25,
      interestRate: .04,
      loanTerm: 30,
      condoFeeInt: 0,
      taxInt: 0,
      repairsInt: 0,
      utilitiesInt: 0,
      inspectionInt: 0,
      attorneyInt: 0,
      closingInt: 0,
      insuranceInt: 0,
      maintenanceInt: 0,
      waterInt: 0,
      trashInt: 0,
      pointsInt:0,
      yearOneRentInt: 0,
      yearTwoRentInt: 0,
      miscIncome: '',
      miscIncomeInt: 0,
      vacancyRate: .0,
      pointsInt: 0,
      bankEscrow: 0,
      email: "",
      address: "",
      firstName: "",
      lastName: "",
      name: "",
      monthlyPI: 0,
      showMenu: false,
      mailSent: false,
      invalidFields: false,
      invalidMessage: "Error",
      mailError:false,
      loading: false,
      message: "EMAIL TEST",
      valueType: ["purchaseInt", "downInt", "mortgageInt", "interestRate", "loanTerm",
      "condoFeeInt", "taxInt", "repairsInt", "utilitiesInt", "inspectionInt", "attorneyInt",
      "closingInt", "insuranceInt", "maintenanceInt", "waterInt", "trashInt", "pointsInt",
      "yearOneRentInt", "yearTwoRentInt", "miscIncomeInt", "vacancyRate",  "bankEscrow"],
      interestOptions: [{name: "2%"}, {name: "2.125%"}, {name: "2.25%"}, {name: "2.375%"},
                        {name: "2.5%"}, {name: "2.625%"}, {name: "2.75%"}, {name: "2.875%"},
                        {name: "3%"}, {name: "3.125%"}, {name: "3.25%"}, {name: "3.375%"},
                        {name: "3.5%"}, {name: "3.625%"}, {name: "3.75%"}, {name: "3.875%"},
                        {name: "4%"}, {name: "4.125%"}, {name: "4.25%"}, {name: "4.375%"},
                        {name: "4.5%"}, {name: "4.625%"}, {name: "4.75%"}, {name: "4.875%"},
                        {name: "5%"}, {name: "5.125%"}, {name: "5.25%"}, {name: "5.375%"},
                        {name: "5.5%"}, {name: "5.625%"}, {name: "5.75%"}, {name: "5.875%"},
                        {name: "6%"}, {name: "6.125%"}, {name: "6.25%"}, {name: "6.375%"},
                        {name: "6.5%"}, {name: "6.625%"}, {name: "6.75%"}, {name: "6.875%"},
                        {name: "7%"}, {name: "7.125%"}, {name: "7.25%"}, {name: "7.375%"},
                        {name: "7.5%"}, {name: "7.625%"}, {name: "7.75%"}, {name: "7.875%"},
                        {name: "8%"}, {name: "8.125%"}, {name: "8.25%"}, {name: "8.375%"},
                        {name: "8.5%"}, {name: "8.625%"}, {name: "8.75%"}, {name: "8.875%"},
                        {name: "9%"}, {name: "9.125%"}, {name: "9.25%"}, {name: "9.375%"},
                        {name: "9.5%"}, {name: "9.625%"}, {name: "9.75%"}, {name: "9.875%"},
                        {name: "10%"}, ],
      vacancyOptions: [{name: "0%"}, {name: "1%"}, {name: "2%"},
                          {name: "3%"},{name: "4%"},{name: "5%"},
                          {name: "6%"}, {name: "7%"}, {name: "8%"},
                          {name: "9%"}, {name: "10%"}],
      width: window.innerWidth,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handlePurchaseChange = this.handlePurchaseChange.bind(this);
    this.handleRent1Change = this.handleRent1Change.bind(this);
    this.handleRent2Change = this.handleRent2Change.bind(this);
    this.formatNumber = this.formatNumber.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInterestRateChange = this.handleInterestRateChange.bind(this);
    this.handleVacancyRateChange = this.handleVacancyRateChange.bind(this);
    this.handleMiscIncomeChange = this.handleMiscIncomeChange.bind(this);
    this.onDownPercentChange = this.onDownPercentChange.bind(this);
    this.onLoanTermChange = this.onLoanTermChange.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }



  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  formatNumber = num => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }


  handleChange = (e, typeId) => {
    let stateToChange = this.state.valueType[typeId];
    this.setState({
      [stateToChange]: e.target.value,
    })
  }

  handleEmailChange = e => {
    this.setState({
      email: e.target.value,
    })
  }

  handleNameChange = e => {
    let name = e.target.value;
    let firstName = "";
    let lastName = "";
    if(name.indexOf(' ') >= 0){
      firstName = name.substring(0, name.indexOf(' '));
      lastName = name.substring(name.indexOf(' '), name.length);
    }else{
      firstName = name;
    }

    this.setState({
      name: e.target.value,
      firstName: firstName,
      lastName: lastName
    })
  }


  handlePurchaseChange = e => {
    let formatted = "NaN";
    let val = e.target.value.length > 1 ?
              e.target.value.substring(1).replace(/,/g, "")
              : e.target.value === "$" ? ""
              : e.target.value.replace(/,/g, "");
    if(parseInt(val) > 999){
      formatted = this.formatNumber(val);
    }
    let final = formatted === "NaN" ? val : formatted;
    //update down payment percentage
    let down = this.state.downInt;
    let percent = Math.round((down / val) * 100);
    this.setState({
      purchasePrice: '$' + final,
      downPercent: percent,
      purchaseInt: val,
    })
  }

  handleRent1Change = e => {
    let formatted = "NaN";
    let val = e.target.value.length > 1 ?
              e.target.value.substring(1).replace(/,/g, "")
              : e.target.value === "$" ? ""
              : e.target.value.replace(/,/g, "");
    if(parseInt(val) > 999){
      formatted = this.formatNumber(val);
    }
    let final = formatted === "NaN" ? val : formatted;
    this.setState({
      yearOneRentFormat: '$' + final,
      yearOneRentInt: val || 0,
    })
  }

  handleRent2Change = e => {
    let formatted = "NaN";
    let val = e.target.value.length > 1 ?
              e.target.value.substring(1).replace(/,/g, "")
              : e.target.value === "$" ? ""
              : e.target.value.replace(/,/g, "");
    if(parseInt(val) > 999){
      formatted = this.formatNumber(val);
    }
    let final = formatted === "NaN" ? val : formatted;
    this.setState({
      yearTwoRentFormat: '$' + final,
      yearTwoRentInt: val || 0,
    })
  }



  handleDownChange = e => {
    let formatted = "NaN";
    let val = e.target.value.length > 1 ?
              e.target.value.substring(1).replace(/,/g, "")
              : e.target.value === "$" ? ""
              : e.target.value.replace(/,/g, "");
    if(parseInt(val) > 999){
      formatted = this.formatNumber(val);
    }
    let final = formatted === "NaN" ? val : formatted;
    //update down payment percentage
    let purchase = this.state.purchaseInt;
    let percent = Math.round((val / purchase) * 100);
    let mortgageInt = purchase - val;
    let mortgageAmount = this.formatNumber(mortgageInt);
    this.setState({
      downPayment: '$' + final,
      downPercent: percent,
      downInt: val,
      mortgageInt: mortgageInt,
      mortgageAmount: '$' + mortgageAmount
    })
  }

  onDownPercentChange = e => {
    let down = 0;
    let purchase = this.state.purchaseInt;
    if(purchase > 0){
      down = this.state.purchaseInt * (parseFloat(e.target.value) / 100);
    }
    let downFormatted = '$' + this.formatNumber(down);
    let mortgageInt = purchase - down;
    let mortgageFormatted= '$' + this.formatNumber(mortgageInt);
    let purchaseFormat = '$' + this.formatNumber(purchase)
    this.setState({
      downPercent: e.target.value,
      downInt: down,
      downPayment: downFormatted,
      mortgageInt: mortgageInt,
      mortgageAmount: mortgageFormatted,
      purchasePrice: purchaseFormat,
    })
  }

  onLoanTermChange = e => {
    let term = parseInt(e.target.value);
    this.setState({
      loanTerm: term
    })
  }


  handleMortgageChange = e => {
    let formatted = "NaN";
    let val = e.target.value.length > 1 ?
              e.target.value.substring(1).replace(/,/g, "")
              : e.target.value === "$" ? ""
              : e.target.value.replace(/,/g, "");
    if(parseInt(val) > 999){
      formatted = this.formatNumber(val);
    }
    let final = formatted === "NaN" ? val : formatted;
    this.setState({
      mortgageAmount: '$' + final,
      mortgageInt: val,
    })
  }

  handleMiscIncomeChange = e => {
    let formatted = "NaN";
    let val = e.target.value.length > 1 ?
              e.target.value.substring(1).replace(/,/g, "")
              : e.target.value === "$" ? ""
              : e.target.value.replace(/,/g, "");
    if(parseInt(val) > 999){
      formatted = this.formatNumber(val);
    }
    let final = formatted === "NaN" ? val : formatted;
    this.setState({
      miscIncome: '$' + final,
      miscIncomeInt: val || 0,
    })
  }

  handleInterestRateChange = e => {
    let rate = this.state.interestOptions[e.target.value].name;
    let numRate = rate.substr(0, rate.length - 1);
    this.setState({interestRate: (parseFloat(numRate) / 100)})
  }

  handleVacancyRateChange = e => {
    let rate = this.state.vacancyOptions[e.target.value].name;
    let numRate = rate.substr(0, rate.length - 1);
    this.setState({vacancyRate: (parseFloat(numRate) / 100)})
  }


  hideModal = (name) => {
    let updatedCaption = this.state.captions;
    updatedCaption[name].show = false;
    this.setState({
      captions: updatedCaption,
    })
  }

  showModal = (name) => {
    let updatedCaption = this.state.captions;
    updatedCaption[name].show = true;
    this.setState({
      captions: updatedCaption,
      descrip: updatedCaption[name].descrip,
    })
  }

  calculateRecurring = () => {
    return (Math.round(parseInt(this.state.condoFeeInt) + parseInt(this.state.taxInt/12) +
    parseInt(this.state.utilitiesInt/12) + parseInt(this.state.insuranceInt/12) +
    parseInt(this.state.maintenanceInt/12) + parseInt(this.state.trashInt/12)));
  }

  calculateUpfrontCosts = () => {
    return (
      Math.round(parseInt(this.state.attorneyInt) + parseInt(this.state.inspectionInt)
        + parseInt(this.state.closingInt) + parseInt(this.state.repairsInt) +
        parseInt(this.state.downInt) + parseInt(this.state.pointsInt) + parseInt(this.state.bankEscrow))
    )
  }

  calculateMonthlyPI = () => {
    let r = parseFloat(this.state.interestRate) / 12;
    let n = parseInt(this.state.loanTerm) * 12;
    let val = this.state.mortgageAmount ?
      Math.round(parseInt(this.state.mortgageInt) * ((r * Math.pow((1 + r), n)) / (Math.pow((1 + r), n) - 1)))
      : 0;
    return val;
  }

  calculateAnnualCashFlow = (rent) => {
    let vacancyRate = 1 - parseFloat(this.state.vacancyRate);
    return (parseInt(rent) * 12) * vacancyRate;
  }

  calculateGrossExpYear1 = (monthlyPI, recurringTotal, annualCashFlow, upfrontCosts) => {
    let exp = Math.round((parseInt(monthlyPI*12)) +
             parseInt(recurringTotal * 12) + parseInt(upfrontCosts) - parseInt(this.state.downInt)
              + (parseFloat(this.state.vacancyRate) * (parseInt(annualCashFlow) + parseInt(this.state.miscIncomeInt))));
    return exp;
  }

  calculateGrossExpYear2 = (monthlyPI, recurringTotal, annualCashFlow2) => {
    return (Math.round((parseInt(monthlyPI*12)) + parseInt(recurringTotal * 12) +
                        (parseFloat(this.state.vacancyRate) *
                          (parseInt(annualCashFlow2) + parseInt(this.state.miscIncomeInt)))));
  }

  calculateInterestPaidYearOne = (months, principal, monthlyPI) => {
    if (months > 0){
      let curInterest = (this.state.interestRate / 12) * principal;
      let newPrincipal = principal - (monthlyPI - curInterest);
      return curInterest + this.calculateInterestPaidYearOne(months - 1, newPrincipal, monthlyPI);
    }else{
      return 0;
    }
  }

  calculateInterestPaidYearTwo = (months, principal, monthlyPI) => {
    if (months > 12){
      let curInterest = (this.state.interestRate / 12) * principal;
      let newPrincipal = principal - (monthlyPI - curInterest);
      return this.calculateInterestPaidYearTwo(months - 1, newPrincipal, monthlyPI);
    }else if(months > 0){
      let curInterest = (this.state.interestRate / 12) * principal;
      let newPrincipal = principal - (monthlyPI - curInterest);
      return curInterest + this.calculateInterestPaidYearTwo(months - 1, newPrincipal, monthlyPI);
    }else{
      return 0;
    }
  }

  calculateROI = (netOp, interestPaid, upfrontCosts) => {
    let roi = (netOp - interestPaid) / (upfrontCosts);
    return Math.round(roi * 10000) / 100;
  }

  calculateEquityIncrease = (monthlyPI, interestPaid) => {
    //equity is the sum of total payments minus interest
    let equity = (parseInt(monthlyPI * 12) - parseInt(interestPaid));
    return equity;
  }

  calculateEquityDividend = (monthlyPI, netOpIncome, equity) => {
    let top = parseInt(netOpIncome) - (parseInt(monthlyPI) * 12);
    let bottom = parseInt(this.state.purchaseInt) - parseInt(equity);
    return (top/bottom);
  }

  calculateROR = (netOp, upfrontCosts) => {
    return Math.round((netOp / upfrontCosts) * 10000) / 100;
  }

  handlePlaceSelect() {
   let addressObject = this.autocomplete.getPlace()
   this.setState({
     address: addressObject.name,
     googleMapLink: addressObject.url,
     mailClicked: false,
   })
 }

  handleScriptLoad = () => {
    const google = window.google;
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {})
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
  }

  showMenu = () => {
    this.setState({
      showMenu: true
    })
  }

  hideMenu = () => {
    this.setState({
      showMenu: false
    })
  }


  handleSubmit(event) {
      event.preventDefault();
      if (this.state.address.length < 1 || this.state.name.length < 1 || this.state.email.length < 1){
        this.setState({
          invalidFields: true,
          invalidMessage: "Please enter information for all fields"
        })
      }else if(this.state.email.indexOf('@') < 0){
        this.setState({
          invalidFields: true,
          invalidMessage: "Please enter a valid email address"
        })
      }else{
          this.setState({
            invalidFields: false,
            loading: true,
          })
          let monthlyPI = this.calculateMonthlyPI();
          let recurringTotal = this.calculateRecurring();
          let upfrontCosts = this.calculateUpfrontCosts();
          let annualCashFlow = this.calculateAnnualCashFlow(this.state.yearOneRentInt);
          let grossExpYear1 = this.calculateGrossExpYear1(monthlyPI, recurringTotal, annualCashFlow, upfrontCosts);
          let annualCashFlow2 = this.calculateAnnualCashFlow(this.state.yearTwoRentInt);
          let grossExpYear2 = this.calculateGrossExpYear2(monthlyPI, recurringTotal, annualCashFlow2);
          let netOpIncome1 = Math.round((parseInt(annualCashFlow) - parseInt(grossExpYear1)) + (parseInt(monthlyPI*12)));
          let netOpIncome2 = Math.round((parseInt(annualCashFlow2) - parseInt(grossExpYear2)) + (parseInt(monthlyPI*12)));
          let interestPaid = Math.round(this.calculateInterestPaidYearOne(12, this.state.mortgageInt, monthlyPI));
          let interestPaid2 = Math.round(this.calculateInterestPaidYearTwo(24, this.state.mortgageInt, monthlyPI));
          let roi1 = this.calculateROI(netOpIncome1, interestPaid, upfrontCosts);
          let roi2 = this.calculateROI(netOpIncome2, interestPaid2, upfrontCosts);
          let equity1 = this.calculateEquityIncrease(monthlyPI, interestPaid);
          let equity2 = this.calculateEquityIncrease(monthlyPI, interestPaid2) + equity1;
          let capRate = Math.round((netOpIncome1 / this.state.purchaseInt) * 10000) / 100;
          let capRate2 = Math.round((netOpIncome2 / this.state.purchaseInt) * 10000) / 100;
          let equityDividendRate = Math.round(this.calculateEquityDividend(monthlyPI, netOpIncome2, equity2) * 10000) / 100;
          let grossMultiplier = Math.round(this.state.purchaseInt / parseInt(annualCashFlow2));
          let ror = this.calculateROR(netOpIncome1, upfrontCosts);
          let json =
              [{

                  "Address": this.state.address || "",
                  "Purchase price":this.state.purchaseInt || 0,
                  "Down payment":this.state.downInt || 0,
                  "Mortgage amount": this.state.mortgageInt || 0,
                  "Mortgage P&I":monthlyPI || 0,
                  "Condo fee": this.state.condoFeeInt || 0,
                  "Annual RE taxes": this.state.taxes || 0,
                  "Immediate repairs": this.state.repairsInt || 0,
                  "Bank's escrow": this.state.bankEscrow || 0,
                  "Inspectional fees":this.state.inspectionInt || 0,
                  "Attorney's fees":this.state.attorneyInt || 0,
                  "Maintainance":this.state.maintenanceInt || 0,
                  "Utilities":  this.state.utilitiesInt || 0,
                  "Points":  this.state.pointsInt || 0,
                  "Closing cost": this.state.closingInt || 0,
                  "Insurance":this.state.insuranceInt || 0,
                  "Trash":   this.state.trashInt || 0,
                  "Vacancy rate": this.state.vacancyRate || 0,
                  "Monthly rent (year 1)":  this.state.yearOneRentInt || 0,
                  "Monthly rent (year 2)": this.state.yearTwoRentInt || 0,
                  "Miscellaneous income":this.state.miscIncomeInt || 0,
                  "Gross expenses (year 1)": grossExpYear1 || 0,
                  "Gross expenses (year 2)": grossExpYear2 || 0,
                  "NOI (year 1)": netOpIncome1 || 0,
                  "NOI (year 2)": netOpIncome2 || 0,
                  "ROI (year 1)": roi1 || 0,
                  "ROI (year 2)": roi2 || 0,
                  "Equity increase (year 1)":equity1 || 0,
                  "Equity increase (year 2)":equity2 || 0,
                  "Cap rate (year 2)":  capRate2 || 0,
                  "Equtiy dividend rate (year 2)":  equityDividendRate || 0,
                  "Rate of return (year 1)":ror || 0 ,
                  "Gross rent multiplier (year 2)":grossMultiplier || 0
              } ];

              const replacer = (key, value) => value === null ? '' : value
              let header = Object.keys(json[0]);
              let csv = json.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
              csv.unshift(header.join(','))
              csv = csv.join('\r\n');

              let message = `Hi ${this.state.firstName},\nYour investment results for ${this.state.address} are attached.`;
              let subject = `Investment results ${this.state.address}`
              let bodyFormData = new FormData();
              bodyFormData.set('email', this.state.email);
              bodyFormData.set('message', message);
              bodyFormData.set('subject', subject);
              bodyFormData.set('csv', csv);

              axios({
                method: 'post',
                url: `${API_PATH}`,
                headers: {'Content-Type': 'multipart/form-data' },
                data:bodyFormData
              })
              .then( response => {
                console.log(response);
                this.setState({mailError: false, mailClicked: true, loading: false})
              })
              .catch(error => {
                console.log(error);
                this.setState({mailError: true, mailClicked: true, loading: false})
              });

        }

    }



  render(){

    let recurringTotal = this.calculateRecurring();
    let upfrontCosts = this.calculateUpfrontCosts();
    let monthlyPI = this.calculateMonthlyPI();
    let vRate = this.state.vacancyRate;
    let interestId = [];
    for(const item in this.state.interestOptions){
      interestId.push(item);
    }

    let vacancyId = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];


    let annualCashFlow = this.calculateAnnualCashFlow(this.state.yearOneRentInt);
    let grossExpYear1 = this.calculateGrossExpYear1(monthlyPI, recurringTotal, annualCashFlow, upfrontCosts);

    let annualCashFlow2 = this.calculateAnnualCashFlow(this.state.yearTwoRentInt);

    let grossExpYear2 = this.calculateGrossExpYear2(monthlyPI, recurringTotal, annualCashFlow2);

    let netOpIncome1 = Math.round((parseInt(annualCashFlow) - parseInt(grossExpYear1)) + (parseInt(monthlyPI*12)));
    let netOpIncome2 = Math.round((parseInt(annualCashFlow2) - parseInt(grossExpYear2)) + (parseInt(monthlyPI*12)));

    let interestPaid = Math.round(this.calculateInterestPaidYearOne(12, this.state.mortgageInt, monthlyPI));
    let interestPaid2 = Math.round(this.calculateInterestPaidYearTwo(24, this.state.mortgageInt, monthlyPI));
    let roi1 = this.calculateROI(netOpIncome1, interestPaid, upfrontCosts);
    let roi2 = this.calculateROI(netOpIncome2, interestPaid2, upfrontCosts);

    let equity1 = this.calculateEquityIncrease(monthlyPI, interestPaid);
    let equity2 = this.calculateEquityIncrease(monthlyPI, interestPaid2) + equity1;

    let capRate = Math.round((netOpIncome1 / this.state.purchaseInt) * 10000) / 100;
    let capRate2 = Math.round((netOpIncome2 / this.state.purchaseInt) * 10000) / 100;
    let equityDividendRate = Math.round(this.calculateEquityDividend(monthlyPI, netOpIncome2, equity2) * 10000) / 100;

    let ror = this.calculateROR(netOpIncome1, upfrontCosts);
    let grossMultiplier = Math.round(this.state.purchaseInt / parseInt(annualCashFlow2));

    const { width } = this.state;
    const isMobile = width <= 1000;

    if(isMobile){
      return (
        <div className="App">
          <div className="mobile-header">
            <img src={logo} alt="menu" className="mobile-logo" onClick={this.showMenu}/>
          {
            this.state.showMenu?
            <div className="mobile-menu">
              <button className="close-button" onClick={this.hideMenu}>
                <i class="fas fa-times"></i>
              </button>
              <ul><li id="menu-item-24" ></li>
                <li className="link"><ul>
                  <li className="link"><a href="http://vow.mlspin.com/clients/signin.aspx?id=37075" target="outside">CLIENT LOGIN</a></li>
                  <li className="link"><a href="http://vow.mlspin.com/idx/index.aspx?id=37075&PageType=1" target="outside">SEARCH PROPERTIES WITH FREE MLS</a></li>
                  <li className="link"><a href="residential.html">RESIDENTIAL</a></li>
                  <li className="link"><a href="commercial.html">COMMERCIAL</a></li>
                  <li className="link"><a href="management.html">PROPERTY MANAGEMENT</a></li>
                  <li className="link"><a href="investor-tools.html">INVESTOR TOOLS</a></li>
                  <li className="link"><a href="testimonials.html">TESTIMONIALS</a></li>
                  <li className="link"><a href="contact.html">CONTACT US</a></li>
                </ul></li>
              </ul>
            </div>
            : null
          }
          <p className="mobile-page-title">Investment tool</p>
          <p className="mobile-warning-message">This investment tool is subject to errors and your accountant or financial
          advisor should verify all calculations if you are relying on this to purchase a property.
          No warranty expressed or implied if you choose to use this.</p>
          </div>
        <Script url="https://maps.googleapis.com/maps/api/js?key=AIzaSyCg3nXlO3Y3q7lvA2ZDZ7xcpn1gyIbMGg0&libraries=places"
          onLoad={this.handleScriptLoad}/>
          <form className="form" onSubmit={(e) => this.handleSubmit(e)}>

            <div className="mobile-col">

                <InputBar header={"Purchase price"} val={this.state.purchasePrice} inputClass="mobile-input" containerClass="mobile-input-container"
                  placeholder={'$500,000'} onChange={this.handlePurchaseChange} showModal={this.showModal}
                  hideModal={this.hideModal} showLabel={this.state.captions.purchase.show} descrip={this.state.captions.purchase.descrip} name="purchase"/>
                <InputBar header={`Down payment (${this.state.downPercent > 0 && this.state.downPercent < 1000000 ? this.state.downPercent : ""}%)`} val={this.state.downPayment}
                  placeholder={'$125,000'} onChange={this.handleDownChange} downPercent={this.state.downPercent} onDownPercentChange={this.onDownPercentChange}
                  showModal={this.showModal} hideModal={this.hideModal} inputClass="mobile-input" containerClass="mobile-input-container"
                showLabel={this.state.captions.down.show} descrip={this.state.captions.down.descrip} name="down"/>
                <InputBar header={"Mortgage amount"} val={this.state.mortgageAmount} inputClass="mobile-input" containerClass="mobile-input-container"
                  placeholder={'$375,000'} onChange={this.handleMortgageChange} showModal={this.showModal}
                  hideModal={this.hideModal} showLabel={this.state.captions.mortgage.show} descrip={this.state.captions.mortgage.descrip} name="mortgage"/>

                <div className='mobile-interest-container'>
                  <div className="input-caption-container">
                    <p className="input-caption">Interest rate</p>
                    {
                      this.state.captions.interest.descrip?
                      <div className="question-container">
                        <button className='help-icon' onMouseEnter={() => this.showModal("interest")} onMouseLeave={() => this.hideModal("interest")}>
                          <i className="far fa-question-circle"></i>
                        </button>
                        {
                          this.state.captions.interest.show ?
                          <div className="label-container">
                            <p className="label-text">{this.state.captions.interest.descrip}</p>
                          </div>
                          : null
                        }
                      </div>
                      : null
                    }

                  </div>

                  <select onChange={e => this.handleInterestRateChange(e)} defaultValue={18} className="interest-select">
                    {interestId.map(id =>
                      <option key={id} value={id}>{this.state.interestOptions[id].name}</option>
                     )}
                  </select>

              <div className='interest-container'>
                <div className="input-caption-container">
                  <p className="input-caption">Loan term (years)</p>
                </div>
                <div className="loan-radio-container">
                  <div className="radio-col">
                    <label for="term1" className="radio-text">10</label>
                    <input type="radio" id="term1" name="term" value="10" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term2" className="radio-text">15</label>
                    <input type="radio" id="term2" name="term" value="15" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term3" className="radio-text">20</label>
                    <input type="radio" id="term3" name="term" value="20" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term4" className="radio-text">25</label>
                    <input type="radio" id="term4" name="term" value="25" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term5" className="radio-text">30</label>
                    <input type="radio" id="term5" name="term" value="30" className="radio-button" onChange={(e) => this.onLoanTermChange(e)} checked={this.state.loanTerm == 30}/>
                  </div>
                </div>
              </div>
            </div>
              <div className="category-container">
                <h2 className="category-caption">One-time fees</h2>
              </div>
              <div className="row">
                <Slider header="Attorney fees" annual={false} val={this.state.attorneyInt}
                  valFormat={this.formatNumber(this.state.attorneyInt)}
                  onChange={this.handleChange} minVal={0} maxVal={10000} typeId={10}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.attorney.show}
                  descrip={this.state.captions.attorney.descrip} name="attorney"/>
                <Slider header="Inspectional fees" annual={false} val={this.state.inspectionInt}
                  valFormat={this.formatNumber(this.state.inspectionInt)}
                  onChange={this.handleChange} minVal={0} maxVal={20000} typeId={9}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.inspection.show}
                  descrip={this.state.captions.inspection.descrip} name="inspection"/>
              </div>
              <div className="row">
                <Slider header="Closing costs" annual={false} val={this.state.closingInt}
                  valFormat={this.formatNumber(this.state.closingInt)}
                  onChange={this.handleChange} minVal={0} maxVal={10000} typeId={11}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.closing.show}
                  descrip={this.state.captions.closing.descrip} name="closing"/>
                <Slider header="Points" annual={false} val={this.state.pointsInt}
                  valFormat={this.formatNumber(this.state.pointsInt)}
                  onChange={this.handleChange} minVal={0} maxVal={10000} typeId={16}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.points.show}
                  descrip={this.state.captions.points.descrip} name="points"/>
              </div>
              <div className="row">
                <Slider header="Bank's escrow" annual={false} val={this.state.bankEscrow}
                  valFormat={this.formatNumber(this.state.bankEscrow)}
                  onChange={this.handleChange} minVal={0} maxVal={25000} typeId={21}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.escrow.show}
                  descrip={this.state.captions.escrow.descrip} name="escrow"/>
                <Slider header="Immediate repairs" annual={false} val={this.state.repairsInt}
                  valFormat={this.formatNumber(this.state.repairsInt)}
                  onChange={this.handleChange} minVal={0} maxVal={100000} typeId={7}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.repairs.show}
                  descrip={this.state.captions.repairs.descrip} name="repairs"/>
              </div>
              <div className="category-container">
                <h2 className="category-caption">Recurring expenses</h2>
              </div>
              <div className="row">
                <Slider header="Condo fee" val={this.state.condoFeeInt}
                  valFormat={this.formatNumber(this.state.condoFeeInt)}
                  onChange={this.handleChange} minVal={0} maxVal={10000} typeId={5}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.condo.show}
                  descrip={this.state.captions.condo.descrip} name="condo"/>
                <Slider header="Real estate tax" annual={true} val={this.state.taxInt}
                  valFormat={this.formatNumber(this.state.taxInt)}
                  onChange={this.handleChange} minVal={0} maxVal={50000} typeId={6}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.tax.show}
                  descrip={this.state.captions.tax.descrip} name="tax"/>
              </div>
              <div className="row">
                <Slider header="Utilities" annual={true} val={this.state.utilitiesInt}
                  valFormat={this.formatNumber(this.state.utilitiesInt)}
                  onChange={this.handleChange} minVal={0} maxVal={100000} typeId={8}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.utilities.show}
                  descrip={this.state.captions.utilities.descrip} name="utilities"/>
                <Slider header="Insurance" annual={true} val={this.state.insuranceInt}
                  valFormat={this.formatNumber(this.state.insuranceInt)}
                  onChange={this.handleChange} minVal={0} maxVal={20000} typeId={12}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.insurance.show}
                  descrip={this.state.captions.insurance.descrip} name="insurance"/>
              </div>
              <div className="row">
                <Slider header="Maintenance" annual={true} val={this.state.maintenanceInt}
                  valFormat={this.formatNumber(this.state.maintenanceInt)}
                  onChange={this.handleChange} minVal={0} maxVal={20000} typeId={13}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.maint.show}
                  descrip={this.state.captions.maint.descrip} name="maint"/>
                <Slider header="Trash" annual={true} val={this.state.trashInt}
                  valFormat={this.formatNumber(this.state.trashInt)}
                  onChange={this.handleChange} minVal={0} maxVal={10000} typeId={15}
                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.trash.show}
                  descrip={this.state.captions.trash.descrip} name="trash"/>
              </div>

              <div className="category-container">
                <h2 className="category-caption">Rental information</h2>
              </div>

              <div className="row">
                <div className='slider-container'>
                  <div className="input-caption-container">
                    <p className="input-caption">Monthly rent (year 1)</p>
                    <div className="question-container">
                      <button className='help-icon' onMouseEnter={() => this.showModal("rent1")} onMouseLeave={() => this.hideModal("rent1")}>
                        <i className="far fa-question-circle"></i>
                      </button>
                      {
                        this.state.captions.rent1.show ?
                        <div className="label-container">
                          <p className="label-text">{this.state.captions.rent1.descrip}</p>
                        </div>
                        : null
                      }
                    </div>
                  </div>
                  <input
                    type="text"
                    placeholder={'$0'}
                    value={this.state.yearOneRentFormat}
                    onChange={this.handleRent1Change}
                    className="small-input"></input>
                </div>

                <div className='slider-container'>
                  <div className="input-caption-container">
                    <p className="input-caption">Monthly rent (year 2)</p>
                    <div className="question-container">
                      <button className='help-icon' onMouseEnter={() => this.showModal("rent2")} onMouseLeave={() => this.hideModal("rent2")}>
                        <i className="far fa-question-circle"></i>
                      </button>
                      {
                        this.state.captions.rent2.show ?
                        <div className="label-container">
                          <p className="label-text">{this.state.captions.rent2.descrip}</p>
                        </div>
                        : null
                      }
                    </div>
                  </div>
                  <input
                    type="text"
                    placeholder={'$0'}
                    value={this.state.yearTwoRentFormat}
                    onChange={this.handleRent2Change}
                    className="small-input"></input>
                </div>

              </div>

              <div className="row">
                <div className='slider-container'>
                  <div className="input-caption-container">
                    <p className="input-caption">Vacancy rate</p>
                    <div className="question-container">
                      <button className='help-icon' onMouseEnter={() => this.showModal("vacancy")} onMouseLeave={() => this.hideModal("vacancy")}>
                        <i className="far fa-question-circle"></i>
                      </button>
                      {
                        this.state.captions.vacancy.show ?
                        <div className="label-container">
                          <p className="label-text">{this.state.captions.vacancy.descrip}</p>
                        </div>
                        : null
                      }
                    </div>
                  </div>
                  <select onChange={e => this.handleVacancyRateChange(e)} defaultValue={0} className="select">
                    {vacancyId.map(id =>
                      <option key={id} value={id}>{this.state.vacancyOptions[id].name}</option>
                     )}
                  </select>
                </div>

                <div className='slider-container'>
                  <div className="input-caption-container">
                    <p className="input-caption">Misc income (annual)</p>
                    <div className="question-container">
                      <button className='help-icon' onMouseEnter={() => this.showModal("miscIncome")} onMouseLeave={() => this.hideModal("miscIncome")}>
                        <i className="far fa-question-circle"></i>
                      </button>
                      {
                        this.state.captions.miscIncome.show ?
                        <div className="label-container">
                          <p className="label-text">{this.state.captions.miscIncome.descrip}</p>
                        </div>
                        : null
                      }
                    </div>
                  </div>
                  <input
                    type="text"
                    placeholder={'$0'}
                    value={this.state.miscIncome}
                    onChange={this.handleMiscIncomeChange}
                    className="small-input"></input>
                </div>
              </div>


              <div className="monthly-payment-mobile">
                <div className="mortgage-calculated">
                  <h2 className="mortgage-head">Your monthly payment</h2>
                  <h1 className="mortgage-number">${this.formatNumber(monthlyPI)}</h1>
                  <p className="mortgage-caption">Mortgage P&I </p>
                </div>
                <div className="mortgage-calculated">
                  <h2 className="mortgage-head">Gross monthly expenses</h2>
                  <h1 className="mortgage-number">${this.formatNumber(monthlyPI + recurringTotal)}</h1>
                  <p className="mortgage-caption">Mortgage + recurring expenses</p>
                </div>
              </div>

                <div className="results">

                  <div className="results-col">
                  <p className="year-text">YEAR ONE</p>
                  <CategoryResults header1="Gross expenses" sub1="Year one" val1={(!isNaN(grossExpYear1)) ? ("$" + this.formatNumber(grossExpYear1) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.grossExpenses1.show}
                                  descrip={this.state.captions.grossExpenses1.descrip} name="grossExpenses1"/>
                  <CategoryResults header1="Net operating income" sub1="Year one" val1={( !isNaN(netOpIncome1)) ? ("$" + this.formatNumber(netOpIncome1 ) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.noi.show}
                                  descrip={this.state.captions.noi.descrip} name="noi"/>
                  <CategoryResults header1="ROI" sub1="Year one" val1={isNaN(roi1) ? "" : (roi1 + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.roi.show}
                                  descrip={this.state.captions.roi.descrip} name="roi"/>
                  <CategoryResults header1="Equity increase" sub1="Year one" val1={"$" + this.formatNumber(equity1)}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.equityIncrease.show}
                                  descrip={this.state.captions.equityIncrease.descrip} name="equityIncrease"/>
                  <CategoryResults header1="Cap rate" sub1="Year two" val1={isNaN(capRate) ? "" : (capRate + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.capRate.show}
                                  descrip={this.state.captions.capRate.descrip} name="capRate"/>
                  <CategoryResults header1="Rate of return" sub1="Year one" val1={isNaN(ror) ? "" : (ror + "%")}
                                showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.ror.show}
                                descrip={this.state.captions.ror.descrip} name="ror"/>
                  </div>
                  <div className="results-col">
                  <p className="year-text">YEAR TWO</p>
                  <CategoryResults header1="Gross expenses" sub1="Year two" val1={( !isNaN(grossExpYear2)) ? ("$" + this.formatNumber(grossExpYear2) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.grossExpenses2.show}
                                  descrip={this.state.captions.grossExpenses2.descrip} name="grossExpenses2"/>
                  <CategoryResults header1="Net operating income" sub1="Year two" val1={( !isNaN(netOpIncome2)) ? ("$" + this.formatNumber(netOpIncome2 ) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.noi2.show}
                                  descrip={this.state.captions.noi2.descrip} name="noi2"/>
                  <CategoryResults header1="ROI" sub1="Year two" val1={isNaN(roi2) ? "" : (roi2 + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.roi2.show}
                                  descrip={this.state.captions.roi2.descrip} name="roi2"/>
                  <CategoryResults header1="Equity increase" sub1="Year two" val1={"$" + this.formatNumber(equity2)}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.equityIncrease2.show}
                                  descrip={this.state.captions.equityIncrease2.descrip} name="equityIncrease2"/>
                  <CategoryResults header1="Equity dividend rate" sub1="Year two" val1={isNaN(equityDividendRate) ? "" : (equityDividendRate + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.equityDividendRate.show}
                                  descrip={this.state.captions.equityDividendRate.descrip} name="equityDividendRate"/>
                  <CategoryResults header1="Gross rent multiplier" sub1="Year two" val1={grossMultiplier < 100 ?  (grossMultiplier): ("0" )}
                                showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.grossRentMult.show}
                                descrip={this.state.captions.grossRentMult.descrip} name="grossRentMult"/>
                  </div>
                </div>
                <div className="cap-rate">
                  <div className="cap-rate-container">
                    <div className="caption">
                      <p className="cap-head">Cap rate</p>
                        {
                          this.state.captions.capRate2.descrip?
                          <div className="question-container">
                            <button className='help-icon' onMouseEnter={this.showModal("capRate2")} onMouseLeave={this.hideModal("capRate2")}>
                              <i className="far fa-question-circle"></i>
                            </button>
                            {
                              this.state.captions.capRate2.show ?
                              <div className="label-container">
                                <p className="label-text">{this.state.captions.capRate2.descrip}</p>
                              </div>
                              : null
                            }
                          </div>
                          : null
                        }
                    </div>
                  </div>
                  <p className="small-sub">YEAR TWO</p>
                  <p className="small-number">{isNaN(capRate2) ? "" : (capRate2 + "%")}</p>
                </div>







            </div>

          </form>

        </div>


      );
    }
/*
<Modal body={this.state.invalidMessage}
  onClose={this.showModal} show={this.state.invalidFields}/>
*/
    else{
      return (
        <div className="App">
          <div className="header">
            <img src={logo} alt="menu" className="logo" onClick={this.showMenu}/>
          {
            this.state.showMenu?
            <div className="menu">
              <button className="close-button" onClick={this.hideMenu}>
                <i class="fas fa-times"></i>
              </button>
              <ul><li id="menu-item-24" ></li>
                <li className="link"><ul>
                  <li className="link"><a href="http://vow.mlspin.com/clients/signin.aspx?id=37075" target="outside">CLIENT LOGIN</a></li>
                  <li className="link"><a href="http://vow.mlspin.com/idx/index.aspx?id=37075&PageType=1" target="outside">SEARCH PROPERTIES WITH FREE MLS</a></li>
                  <li className="link"><a href="residential.html">RESIDENTIAL</a></li>
                  <li className="link"><a href="commercial.html">COMMERCIAL</a></li>
                  <li className="link"><a href="management.html">PROPERTY MANAGEMENT</a></li>
                  <li className="link"><a href="investor-tools.html">INVESTOR TOOLS</a></li>
                  <li className="link"><a href="testimonials.html">TESTIMONIALS</a></li>
                  <li className="link"><a href="contact.html">CONTACT US</a></li>
                </ul></li>
              </ul>
            </div>
            : null
          }
            <p className="page-title">Investment tool</p>
            <p className="warning-message">This investment tool is subject to errors and your accountant or financial
            advisor should verify all calculations if you are relying on this to purchase a property.
            No warranty expressed or implied if you choose to use this.</p>
          </div>


        <Script url="https://maps.googleapis.com/maps/api/js?key=AIzaSyCg3nXlO3Y3q7lvA2ZDZ7xcpn1gyIbMGg0&libraries=places"
          onLoad={this.handleScriptLoad}/>
          <form className="form" onSubmit={(e) => this.handleSubmit(e)}>
            <div className="row">
              <InputBar header={"Purchase price"} val={this.state.purchasePrice} inputClass="input" containerClass="input-container"
                placeholder={'$500,000'} onChange={this.handlePurchaseChange} showModal={this.showModal}
                hideModal={this.hideModal} showLabel={this.state.captions.purchase.show} descrip={this.state.captions.purchase.descrip} name="purchase"/>
              <InputBar header={`Down payment (${this.state.downPercent > 0 && this.state.downPercent < 1000000 ? this.state.downPercent : ""}%)`} val={this.state.downPayment}
                placeholder={'$125,000'} onChange={this.handleDownChange} downPercent={this.state.downPercent} onDownPercentChange={this.onDownPercentChange}
                showModal={this.showModal} hideModal={this.hideModal} inputClass="input" containerClass="input-container"
                showLabel={this.state.captions.down.show} descrip={this.state.captions.down.descrip} name="down"/>
              <InputBar header={"Mortgage amount"} val={this.state.mortgageAmount} inputClass="input" containerClass="input-container"
                placeholder={'$375,000'} onChange={this.handleMortgageChange} showModal={this.showModal}
                hideModal={this.hideModal} showLabel={this.state.captions.mortgage.show} descrip={this.state.captions.mortgage.descrip} name="mortgage"/>
                <div className='interest-container'>
                  <div className="input-caption-container">
                    <p className="input-caption">Interest rate</p>
                    {
                      this.state.captions.interest.descrip?
                      <div className="question-container">
                        <button className='help-icon' onMouseEnter={() => this.showModal("interest")} onMouseLeave={() => this.hideModal("interest")}>
                          <i className="far fa-question-circle"></i>
                        </button>
                        {
                          this.state.captions.interest.show ?
                          <div className="label-container">
                            <p className="label-text">{this.state.captions.interest.descrip}</p>
                          </div>
                          : null
                        }
                      </div>
                      : null
                    }

                  </div>
                  <select onChange={e => this.handleInterestRateChange(e)} defaultValue={18} className="interest-select">
                    {interestId.map(id =>
                      <option key={id} value={id}>{this.state.interestOptions[id].name}</option>
                     )}
                  </select>
              </div>
              <div className='interest-container'>
                <div className="input-caption-container">
                  <p className="input-caption">Loan term (years)</p>
                </div>
                <div className="loan-radio-container">
                  <div className="radio-col">
                    <label for="term1" className="radio-text">10</label>
                    <input type="radio" id="term1" name="term" value="10" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term2" className="radio-text">15</label>
                    <input type="radio" id="term2" name="term" value="15" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term3" className="radio-text">20</label>
                    <input type="radio" id="term3" name="term" value="20" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term4" className="radio-text">25</label>
                    <input type="radio" id="term4" name="term" value="25" className="radio-button" onChange={(e) => this.onLoanTermChange(e)}/>
                  </div>
                  <div className="radio-col">
                    <label for="term5" className="radio-text">30</label>
                    <input type="radio" id="term5" name="term" value="30" className="radio-button" onChange={(e) => this.onLoanTermChange(e)} checked={this.state.loanTerm == 30}/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="category-container">
                  <h2 className="category-caption">Recurring expenses</h2>
                </div>
                <div className="row">
                  <Slider header="Condo fee" val={this.state.condoFeeInt}
                    valFormat={this.formatNumber(this.state.condoFeeInt)}
                    onChange={this.handleChange} minVal={0} maxVal={10000} typeId={5}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.condo.show}
                    descrip={this.state.captions.condo.descrip} name="condo"/>
                  <Slider header="Real estate tax" annual={true} val={this.state.taxInt}
                    valFormat={this.formatNumber(this.state.taxInt)}
                    onChange={this.handleChange} minVal={0} maxVal={50000} typeId={6}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.tax.show}
                    descrip={this.state.captions.tax.descrip} name="tax"/>
                </div>
                <div className="row">
                  <Slider header="Utilities" annual={true} val={this.state.utilitiesInt}
                    valFormat={this.formatNumber(this.state.utilitiesInt)}
                    onChange={this.handleChange} minVal={0} maxVal={100000} typeId={8}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.utilities.show}
                    descrip={this.state.captions.utilities.descrip} name="utilities"/>
                  <Slider header="Insurance" annual={true} val={this.state.insuranceInt}
                    valFormat={this.formatNumber(this.state.insuranceInt)}
                    onChange={this.handleChange} minVal={0} maxVal={20000} typeId={12}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.insurance.show}
                    descrip={this.state.captions.insurance.descrip} name="insurance"/>
                </div>
                <div className="row">
                  <Slider header="Maintenance" annual={true} val={this.state.maintenanceInt}
                    valFormat={this.formatNumber(this.state.maintenanceInt)}
                    onChange={this.handleChange} minVal={0} maxVal={20000} typeId={13}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.maint.show}
                    descrip={this.state.captions.maint.descrip} name="maint"/>
                  <Slider header="Trash" annual={true} val={this.state.trashInt}
                    valFormat={this.formatNumber(this.state.trashInt)}
                    onChange={this.handleChange} minVal={0} maxVal={10000} typeId={15}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.trash.show}
                    descrip={this.state.captions.trash.descrip} name="trash"/>
                </div>

                <div className="category-container">
                  <h2 className="category-caption">Rental information</h2>
                </div>

                <div className="row">
                  <div className='slider-container'>
                    <div className="input-caption-container">
                      <p className="input-caption">Monthly rent (year 1)</p>
                      <div className="question-container">
                        <button className='help-icon' onMouseEnter={() => this.showModal("rent1")} onMouseLeave={() => this.hideModal("rent1")}>
                          <i className="far fa-question-circle"></i>
                        </button>
                        {
                          this.state.captions.rent1.show ?
                          <div className="label-container">
                            <p className="label-text">{this.state.captions.rent1.descrip}</p>
                          </div>
                          : null
                        }
                      </div>
                    </div>
                    <input
                      type="text"
                      placeholder={'$0'}
                      value={this.state.yearOneRentFormat}
                      onChange={this.handleRent1Change}
                      className="small-input"></input>
                  </div>

                  <div className='slider-container'>
                    <div className="input-caption-container">
                      <p className="input-caption">Monthly rent (year 2)</p>
                      <div className="question-container">
                        <button className='help-icon' onMouseEnter={() => this.showModal("rent2")} onMouseLeave={() => this.hideModal("rent2")}>
                          <i className="far fa-question-circle"></i>
                        </button>
                        {
                          this.state.captions.rent2.show ?
                          <div className="label-container">
                            <p className="label-text">{this.state.captions.rent2.descrip}</p>
                          </div>
                          : null
                        }
                      </div>
                    </div>
                    <input
                      type="text"
                      placeholder={'$0'}
                      value={this.state.yearTwoRentFormat}
                      onChange={this.handleRent2Change}
                      className="small-input"></input>
                  </div>

                </div>

                <div className="row">
                  <div className='slider-container'>
                    <div className="input-caption-container">
                      <p className="input-caption">Vacancy rate</p>
                      <div className="question-container">
                        <button className='help-icon' onMouseEnter={() => this.showModal("vacancy")} onMouseLeave={() => this.hideModal("vacancy")}>
                          <i className="far fa-question-circle"></i>
                        </button>
                        {
                          this.state.captions.vacancy.show ?
                          <div className="label-container">
                            <p className="label-text">{this.state.captions.vacancy.descrip}</p>
                          </div>
                          : null
                        }
                      </div>
                    </div>
                    <select onChange={e => this.handleVacancyRateChange(e)} defaultValue={0} className="select">
                      {vacancyId.map(id =>
                        <option key={id} value={id}>{this.state.vacancyOptions[id].name}</option>
                       )}
                    </select>
                  </div>

                  <div className='slider-container'>
                    <div className="input-caption-container">
                      <p className="input-caption">Misc income (annual)</p>
                      <div className="question-container">
                        <button className='help-icon' onMouseEnter={() => this.showModal("miscIncome")} onMouseLeave={() => this.hideModal("miscIncome")}>
                          <i className="far fa-question-circle"></i>
                        </button>
                        {
                          this.state.captions.miscIncome.show ?
                          <div className="label-container">
                            <p className="label-text">{this.state.captions.miscIncome.descrip}</p>
                          </div>
                          : null
                        }
                      </div>
                    </div>
                    <input
                      type="text"
                      placeholder={'$0'}
                      value={this.state.miscIncome}
                      onChange={this.handleMiscIncomeChange}
                      className="small-input"></input>
                  </div>

                </div>


              </div>

              <div >
                <div className="monthly-payment-container">
                  <div className="mortgage-calculated">
                    <h2 className="mortgage-head">Your monthly payment</h2>
                    <h1 className="mortgage-number">${this.formatNumber(monthlyPI)}</h1>
                    <p className="mortgage-caption">Mortgage P&I </p>
                  </div>
                  <div className="mortgage-calculated">
                    <h2 className="mortgage-head">Gross monthly expenses</h2>
                    <h1 className="mortgage-number">${this.formatNumber(monthlyPI + recurringTotal)}</h1>
                    <p className="mortgage-caption">Mortgage + recurring expenses</p>
                  </div>

                </div>

                <div className="results">
                  <div className="results-col">
                  <p className="year-text">YEAR ONE</p>
                  <CategoryResults header1="Gross expenses" sub1="Year one" val1={(!isNaN(grossExpYear1)) ? ("$" + this.formatNumber(grossExpYear1) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.grossExpenses1.show}
                                  descrip={this.state.captions.grossExpenses1.descrip} name="grossExpenses1"/>
                  <CategoryResults header1="Net operating income" sub1="Year one" val1={( !isNaN(netOpIncome1)) ? ("$" + this.formatNumber(netOpIncome1 ) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.noi.show}
                                  descrip={this.state.captions.noi.descrip} name="noi"/>
                  <CategoryResults header1="ROI" sub1="Year one" val1={isNaN(roi1) ? "" : (roi1 + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.roi.show}
                                  descrip={this.state.captions.roi.descrip} name="roi"/>
                  <CategoryResults header1="Equity increase" sub1="Year one" val1={"$" + this.formatNumber(equity1)}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.equityIncrease.show}
                                  descrip={this.state.captions.equityIncrease.descrip} name="equityIncrease"/>
                  <CategoryResults header1="Cap rate" sub1="Year two" val1={isNaN(capRate) ? "" : (capRate + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.capRate.show}
                                  descrip={this.state.captions.capRate.descrip} name="capRate"/>
                  <CategoryResults header1="Rate of return" sub1="Year one" val1={isNaN(ror) ? "" : (ror + "%")}
                                showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.ror.show}
                                descrip={this.state.captions.ror.descrip} name="ror"/>
                  </div>
                  <div className="results-col">
                  <p className="year-text">YEAR TWO</p>
                  <CategoryResults header1="Gross expenses" sub1="Year two" val1={( !isNaN(grossExpYear2)) ? ("$" + this.formatNumber(grossExpYear2) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.grossExpenses2.show}
                                  descrip={this.state.captions.grossExpenses2.descrip} name="grossExpenses2"/>
                  <CategoryResults header1="Net operating income" sub1="Year two" val1={( !isNaN(netOpIncome2)) ? ("$" + this.formatNumber(netOpIncome2 ) ): ""}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.noi2.show}
                                  descrip={this.state.captions.noi2.descrip} name="noi2"/>
                  <CategoryResults header1="ROI" sub1="Year two" val1={isNaN(roi2) ? "" : (roi2 + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.roi2.show}
                                  descrip={this.state.captions.roi2.descrip} name="roi2"/>
                  <CategoryResults header1="Equity increase" sub1="Year two" val1={"$" + this.formatNumber(equity2)}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.equityIncrease2.show}
                                  descrip={this.state.captions.equityIncrease2.descrip} name="equityIncrease2"/>
                  <CategoryResults header1="Equity dividend rate" sub1="Year two" val1={isNaN(equityDividendRate) ? "" : (equityDividendRate + "%")}
                                  showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.equityDividendRate.show}
                                  descrip={this.state.captions.equityDividendRate.descrip} name="equityDividendRate"/>
                  <CategoryResults header1="Gross rent multiplier" sub1="Year two" val1={grossMultiplier < 100 ?  (grossMultiplier): ("0" )}
                                showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.grossRentMult.show}
                                descrip={this.state.captions.grossRentMult.descrip} name="grossRentMult"/>
                  </div>
                </div>


                <div className="cap-rate">
                  <div className="cap-rate-container">
                    <div className="caption">
                      <p className="cap-head">Cap rate</p>
                        {
                          this.state.captions.capRate2.descrip?
                          <div className="question-container">
                            <button className='help-icon' onMouseEnter={this.showModal("capRate2")} onMouseLeave={this.hideModal("capRate2")}>
                              <i className="far fa-question-circle"></i>
                            </button>
                            {
                              this.state.captions.capRate2.show ?
                              <div className="label-container">
                                <p className="label-text">{this.state.captions.capRate2.descrip}</p>
                              </div>
                              : null
                            }
                          </div>
                          : null
                        }
                    </div>
                  </div>
                  <p className="small-sub">YEAR TWO</p>
                  <p className="small-number">{isNaN(capRate2) ? "" : (capRate2+ "%")}</p>
                </div>

              </div>

              <div className="col">
                <div className="category-container">
                  <h2 className="category-caption">One-time fees</h2>
                </div>
                <div className="row">
                  <Slider header="Attorney fees" annual={false} val={this.state.attorneyInt}
                    valFormat={this.formatNumber(this.state.attorneyInt)}
                    onChange={this.handleChange} minVal={0} maxVal={10000} typeId={10}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.attorney.show}
                    descrip={this.state.captions.attorney.descrip} name="attorney"/>
                  <Slider header="Inspectional fees" annual={false} val={this.state.inspectionInt}
                    valFormat={this.formatNumber(this.state.inspectionInt)}
                    onChange={this.handleChange} minVal={0} maxVal={20000} typeId={9}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.inspection.show}
                    descrip={this.state.captions.inspection.descrip} name="inspection"/>
                </div>
                <div className="row">
                  <Slider header="Closing costs" annual={false} val={this.state.closingInt}
                    valFormat={this.formatNumber(this.state.closingInt)}
                    onChange={this.handleChange} minVal={0} maxVal={10000} typeId={11}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.closing.show}
                    descrip={this.state.captions.closing.descrip} name="closing"/>
                  <Slider header="Points" annual={false} val={this.state.pointsInt}
                    valFormat={this.formatNumber(this.state.pointsInt)}
                    onChange={this.handleChange} minVal={0} maxVal={10000} typeId={16}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.points.show}
                    descrip={this.state.captions.points.descrip} name="points"/>
                </div>
                <div className="row">
                  <Slider header="Bank's escrow" annual={false} val={this.state.bankEscrow}
                    valFormat={this.formatNumber(this.state.bankEscrow)}
                    onChange={this.handleChange} minVal={0} maxVal={25000} typeId={21}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.escrow.show}
                    descrip={this.state.captions.escrow.descrip} name="escrow"/>
                  <Slider header="Immediate repairs" annual={false} val={this.state.repairsInt}
                    valFormat={this.formatNumber(this.state.repairsInt)}
                    onChange={this.handleChange} minVal={0} maxVal={500000} typeId={7}
                    showModal={this.showModal} hideModal={this.hideModal} showLabel={this.state.captions.repairs.show}
                    descrip={this.state.captions.repairs.descrip} name="repairs"/>
                </div>

                <div className = "save-results">
                  <div className="category-container">
                    <h2 className="category-caption">Save my results</h2>
                    {this.state.invalidFields?
                      <p className="invalid-fields">{this.state.invalidMessage}</p>
                      : null
                    }
                  </div>
                  <div className="location-input-container">
                    <input id="autocomplete"
                      className="location-input"
                      placeholder="Address of property"
                      ref="input"
                      type="text"/>
                  </div>

                  <div>
                    <div className="input-caption-container">
                      <p className="input-caption">Name</p>
                    </div>
                    <input
                      type="text"
                      placeholder="John Doe"
                      value={this.state.name}
                      onChange={(e) => this.handleNameChange(e)}
                      className="email-input"></input>
                  </div>

                  <div>
                    <div className="input-caption-container">
                      <p className="input-caption">Email</p>
                    </div>
                    <input
                      type="text"
                      placeholder="johndoe@gmail.com"
                      value={this.state.email}
                      onChange={(e) => this.handleEmailChange(e)}
                      className="email-input"></input>
                  </div>
                  {
                    this.state.loading?
                    <div className="loader"></div>
                    :
                    this.state.mailClicked && !this.state.mailError?
                    <p className="mail-sent">Your email has been sent</p>
                    :
                    this.state.mailClicked && this.state.mailError?
                    <p>Sorry, we encountered an error trying to send your an email</p>
                    :
                    <input type="submit" value="Email me a copy of my investment results" className="email-button"></input>
                  }

                </div>


              </div>
            </div>
          </form>
        </div>
      );

    }


  }
}


export default App;
/*
<div className = "save-results">
  <div className="category-container">
    <h2 className="category-caption">Save my results</h2>
  </div>
  <div className="location-input-container">
    <input id="autocomplete"
      className="location-input"
      placeholder="Address of property"
      ref="input"
      type="text"/>
  </div>

  <div>
    <div className="input-caption-container">
      <p className="input-caption">Name</p>
    </div>
    <input
      type="text"
      placeholder="John Doe"
      value={this.state.name}
      onChange={(e) => this.handleNameChange(e)}
      className="email-input"></input>
  </div>

  <div>
    <div className="input-caption-container">
      <p className="input-caption">Email</p>
    </div>
    <input
      type="text"
      placeholder="johndoe@gmail.com"
      value={this.state.email}
      onChange={(e) => this.handleEmailChange(e)}
      className="email-input"></input>
  </div>

  <input type="submit" value="Email me a copy of my investment results" onClick={e => this.handleSubmit(e)} className="email-button"></input>
</div>


*/
